/**
 * Whether a child is a vnode whose `className` attr includes `cls`.
 */
export default function isVnodeWithClass(child, cls) {
  var _attrs;
  if (!child || typeof child !== 'object' || Array.isArray(child)) return false;
  const className = (_attrs = child.attrs) == null ? void 0 : _attrs.className;
  return typeof className === 'string' && className.split(' ').includes(cls);
}
flarum.reg.add('glowingblue-search', 'forum/utils/isVnodeWithClass', isVnodeWithClass);